import { tv, type VariantProps } from "tailwind-variants";

export const galleryVariant = tv({
  slots: {
    base: ["w-full", "py-4", "desktop:py-2.5"],
    wrapper: ["container-fluid", "flex", "flex-wrap", "w-full"],
    figure: [
      "relative",
      "w-full",
      "lg:w-1/2 nth-[3n]:lg:w-full",
      "box-border",
      "nth-[3n+1]:lg:pr-2 nth-[3n+2]:lg:pl-2 pb-5",
    ],
    image: ["object-cover", "w-full", "rounded-2xl", "overflow-hidden"],
  },
  variants: {
    contentOrder: {
      imageContent: {
        wrapper: ["flex-col", "lg:flex-row"],
      },
      contentImage: {
        wrapper: ["flex-row-reverse", "lg:flex-col-reverse"],
      },
    },
  },
  defaultVariants: {},
});

export type GalleryVariantProps = VariantProps<typeof galleryVariant>;
export type GalleryReturnVariantProps = ReturnType<typeof galleryVariant>;
